module.exports = __webpack_public_path__ + "static/media/tang.48fc3e38.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catbot/tang.png
// module id = 150
// module chunks = 0